import { useLayoutEffect, useRef, useState } from 'react';

// Mesure la distance entre le haut du document et l'élément référencé.
// Sert à alimenter `scrollMargin` de `useWindowVirtualizer` : comme la fenêtre
// est l'élément de scroll, le virtualizer doit connaître l'offset de la liste
// dans le document pour positionner correctement les éléments virtualisés.
export default function useScrollMargin<T extends HTMLElement>() {
    const ref = useRef<T>(null);
    const [scrollMargin, setScrollMargin] = useState(0);

    useLayoutEffect(() => {
        const measure = () => {
            if (ref.current) {
                setScrollMargin(ref.current.getBoundingClientRect().top + window.scrollY);
            }
        };

        measure();
        window.addEventListener('resize', measure);

        return () => window.removeEventListener('resize', measure);
    }, []);

    return { ref, scrollMargin };
}
